import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { TextButton } from '../../components/Button/Button.styles';

export const LinkButton = TextButton.withComponent(Link);

export const StyledLink = styled(LinkButton)`
  text-decoration: none;
`;
